module.exports = __webpack_public_path__ + "img/Question.d8a6347e.svg";